<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    xander<luoxingzhang@frippler.com>
  | @Title:     快速入门组件
  | @Version:   2021-04-15  [A] 新建文件
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="guide" :style="{ width: width, height: height }">
    <div class="container flex">
      <div class="container-nav flex column">
        <!-- 标题、副标题 -->
        <div class="header flex column">
          <span class="font-lg text-bold pb">{{ nav_title }}</span>
          <span v-html="nav_sm_title"></span>
        </div>
        <!-- 快速入门 -->
        <!-- <div v-if="active === 'start'" class="start-body">
          <div class="flex column">
            <span class="text-muted pb-sm">平台名称</span>
            <el-input v-model="sys_title" style="width: 270px"></el-input>
          </div>
          <div class="flex column mt-hg">
            <span class="text-muted pb-sm">LOGO</span>
            <f-image-card-uploader :files="logoArr" :limit="1" :url="uploadUrl" aimPath="custom/" @change="onLogoChange" />
          </div>
        </div> -->
        <div v-if="active === 'start'" class="start-footer" style="margin-top: 350px;">
          <el-button type="success" @click="jumpTo('next')">下一步</el-button>
          <span class="ml-hg">
            <el-button class="text-muted" style="border: none; padding: 0" @click="jumpGuide()">跳过教学</el-button>
          </span>
        </div>
        <!-- 远程监控原理 -->
        <div v-if="active === 'monitor'" class="monitor-body">
          <div class="flex item mb-lg">
            <img class="mon-icon" src="@/assets/cloud-icon.png" alt="" />
            <div class="flex column pl">
              <span class="font-md pb-xs">云平台</span>
              <span class="text-muted">下发指令，解析数据，可视化展示</span>
            </div>
          </div>
          <div class="flex item mb-lg">
            <img class="mon-icon" src="@/assets/model-icon.png" alt="" />
            <div class="flex column pl">
              <span class="font-md pb-xs">通讯模块</span>
              <span class="text-muted">在平台与设备直接传递数据</span>
            </div>
          </div>
          <div class="flex item">
            <img class="mon-icon" src="@/assets/equip-icon.png" alt="" />
            <div class="flex column pl">
              <span class="font-md pb-xs">物理设备</span>
              <span class="text-muted">PLC、触摸屏等，负责底层数据采集</span>
            </div>
          </div>
        </div>
        <!-- 添加设备 -->
        <div v-if="active === 'equip'" class="equip-body">
          <div class="flex-center column">
            <img style="width: 176px; height: 209px" src="@/assets/wechat-qrcode.jpg" alt="" />
            <div style="width: 100%; margin-top: 80px; padding-top: 10px; border-top: 1px solid #bbbbbb">
              <span class="text-muted">若您的设备自带远程通讯能力，也可以联系我们接入平台</span>
            </div>
          </div>
        </div>
        <!-- 添加模型 -->
        <div v-if="active === 'addmodel'" class="addmodel-body">
          <div class="flex align-items-center mb-hg">
            <span class="model-num">1</span>
            <div class="flex column ml">
              <span style="font-size: 1.1em">自主创建</span>
              <span class="text-muted pt-xs font-sm">根据控制器通讯协议自主建模，需要一定的技术基础</span>
            </div>
          </div>
          <div class="flex align-items-center mb-hg">
            <span class="model-num">2</span>
            <div class="flex column ml">
              <span style="font-size: 1.1em">克隆模型</span>
              <span class="text-muted pt-xs font-sm">从已有模型或模型广场克隆，快速创建相似模型</span>
            </div>
          </div>
          <div class="flex align-items-center">
            <span class="model-num">3</span>
            <div class="flex column ml">
              <span style="font-size: 1.1em">建模服务</span>
              <span class="text-muted pt-xs font-sm">不会建模？联系我们，获取代建模型服务</span>
            </div>
          </div>
        </div>
        <!-- 加载模型 -->
        <div v-if="active === 'loadmodel'" class="loadmodel-body">
          <div class="flex align-items-center">
            <div class="flex column align-items-center">
              <i class="iconfont icon-Dev model-icon text-primary"></i>
              <span class="pt-xs">演示模型</span>
            </div>
            <div class="arrow-img flex-center">
              <img src="@/assets/arrow-up.png" alt="" />
            </div>
            <div class="flex column align-items-center">
              <img class="model-icon" src="@/assets/model-icon.png" alt="" />
              <span class="pt-xs">演示设备</span>
            </div>
          </div>
        </div>
        <!-- 扫码体验 -->
        <div v-if="active === 'experience'" class="experience-body">
          <div class="flex-center column mt">
            <img class="go-img" :src="equip_go_url" alt="" />
            <el-button type="success" @click="jumpGuide()">开始使用</el-button>
          </div>
          <div style="margin-top: 240px">
            <el-button class="text-muted" style="border: none; padding: 0" @click="jumpTo('pre')">返回上一步</el-button>
          </div>
        </div>
        <!-- 共用底部（大部分） -->
        <div v-if="active !== 'start' && active !== 'experience'" class="common-footer">
          <div>
            <el-button v-loading="loading" type="success" @click="jumpTo('next')">下一步</el-button>
          </div>
          <div class="flex mt-hg" style="justify-content: space-between">
            <el-button class="text-muted" style="border: none; padding: 0" @click="jumpTo('pre')">返回上一步</el-button>
            <el-button class="text-muted" style="border: none; padding: 0" @click="jumpGuide()">跳过教学</el-button>
          </div>
        </div>
      </div>
      <div v-if="active !== 'experience'" class="container-content flex column">
        <!-- 顶部标签 -->
        <div class="top-tag">
          <div v-if="active === 'addmodel' || active === 'loadmodel'" class="flex">
            <div class="tag-item" v-for="(item, index) in content_arr" :key="item">
              <img v-if="index == 0" class="bg" src="@/assets/arrow-bg-sm.png" alt="" />
              <img v-else class="bg" src="@/assets/arrow-bg-connect.png" alt="" />
              <span v-if="index == 0" class="title font-2x">{{ item }}</span>
              <span v-else class="item-title font-2x">{{ item }}</span>
            </div>
          </div>
          <div v-else>
            <img v-if="content_title.length === 4" class="bg" src="@/assets/arrow-bg-sm.png" alt="" />
            <img v-else-if="content_title.length === 5" class="bg" src="@/assets/arrow-bg-md.png" alt="" />
            <img v-else-if="content_title.length > 5" class="bg" src="@/assets/arrow-bg-lg.png" alt="" />
            <span class="title font-2x">{{ content_title }}</span>
          </div>
        </div>
        <!-- 中心内容 -->
        <div class="body">
          <!-- 快速入门 -->
          <div v-if="active === 'start'">
            <img class="bg box-shadow" src="@/assets/quick-start.jpg" alt="" />
            <img v-if="logo.logo_url" class="logo" :src="logo.logo_url" alt="" />
            <span class="sys-title font-md">{{ sys_title ? sys_title : default_sys_title }}</span>
            <div class="text-white user-info font-md flex align-items-center">
              <!-- <f-svg-icon icon-name="message" class="font-md" />
              <f-svg-icon icon-name="headset" class="ml font-md" /> -->
              <span class="ml">{{ $store.state.userStore.username }}</span>
            </div>
          </div>
          <!-- 远程通讯原理 -->
          <div v-else-if="active === 'monitor'" class="flex column align-items-center">
            <img class="monitor-img" :style="timerIndex > 0 ? 'opacity:1' : 'opacity:0'" src="@/assets/user-layer.png" alt="" />
            <div class="flex link-layer">
              <div :style="timerIndex > 4 ? 'opacity:1' : 'opacity:0'" class="link-layer-item flex align-items-center">
                <span>用户操作</span>
                <img style="height: 60px" src="@/assets/arrow-down.png" alt="" />
              </div>
              <div :style="timerIndex > 9 ? 'opacity:1' : 'opacity:0'" class="link-layer-item flex align-items-center">
                <img style="height: 60px" src="@/assets/arrow-up.png" alt="" />
                <span>数据可视化</span>
              </div>
            </div>
            <img :style="timerIndex > 1 ? 'opacity:1' : 'opacity:0'" class="monitor-img" src="@/assets/app-layer.png" alt="" />
            <div class="flex link-layer">
              <div :style="timerIndex > 5 ? 'opacity:1' : 'opacity:0'" class="link-layer-item flex align-items-center">
                <span>下发指令</span>
                <img style="height: 60px" src="@/assets/arrow-down.png" alt="" />
              </div>
              <div :style="timerIndex > 8 ? 'opacity:1' : 'opacity:0'" class="link-layer-item flex align-items-center">
                <img style="height: 60px" src="@/assets/arrow-up.png" alt="" />
                <span>转发响应</span>
              </div>
            </div>
            <img :style="timerIndex > 2 ? 'opacity:1' : 'opacity:0'" class="monitor-img" src="@/assets/transfer-layer.png" alt="" />
            <div class="flex link-layer">
              <div :style="timerIndex > 6 ? 'opacity:1' : 'opacity:0'" class="link-layer-item flex align-items-center">
                <span>转发指令</span>
                <img style="height: 60px" src="@/assets/arrow-down.png" alt="" />
              </div>
              <div :style="timerIndex > 7 ? 'opacity:1' : 'opacity:0'" class="link-layer-item flex align-items-center">
                <img style="height: 60px" src="@/assets/arrow-up.png" alt="" />
                <span>响应指令</span>
              </div>
            </div>
            <img :style="timerIndex > 3 ? 'opacity:1' : 'opacity:0'" class="monitor-img" src="@/assets/equip-layer.png" alt="" />
          </div>
          <!-- 添加设备 -->
          <div v-else-if="active === 'equip'">
            <img style="width: 100%" src="@/assets/addequip.jpg" alt="" />
          </div>
          <!-- 创建模型 -->
          <div v-else-if="active === 'addmodel'">
            <img class="box-shadow" style="width: 100%" src="@/assets/addmodel.gif" alt="" />
          </div>
          <!-- 加载模型 -->
          <div v-else-if="active === 'loadmodel'">
            <img class="box-shadow" style="width: 100%" src="@/assets/loadmodel.gif" alt="" />
          </div>
        </div>
        <!-- 底部标签 -->
        <div class="bottom-tag">
          <img class="bg" src="@/assets/arrow-bg-other.png" alt="" />
        </div>
      </div>
      <div v-else style="flex: auto; height: 100%">
        <img style="width: 100%; height: 100%; min-width: 1080px" src="@/assets/experience-bg.jpg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { loadEquipModelApi, getDemoEquipApi } from '@/api/common/guideApi'
export default {
  components: {
    FImageCardUploader: () => import('@/components/FImageCardUploader')
  },

  computed: {
    logoArr() {
      const arr = []
      if (!this.logo.logo_url || !this.logo.flag) {
        return []
      }
      arr.push({
        url: this.logo.logo_url
      })
      return arr
    },
    customization() {
      return this.$store.state.godStore.customization
    }
  },

  watch: {
    customization() {
      this.initData()
    }
  },

  mounted() {
    clearInterval(this.timer)
    let that = this
    window.onresize = () => {
      return (() => {
        that.height = document.documentElement.clientHeight + 'px' // 高
        that.width = document.documentElement.clientWidth + 'px' // 宽
      })()
    }
  },

  created() {
    this.initData()
  },

  data() {
    return {
      width: document.documentElement.clientWidth + 'px',
      height: document.documentElement.clientHeight + 'px',
      loading: false,

      active: 'start',
      timer: null, // 定时器
      timerIndex: 0, // 定时器计数
      nav_title: '快速入门',
      nav_sm_title: '欢迎使用鱼漾云',
      content_title: 'Welcome',
      content_arr: ['添加设备', '创建模型'],
      equip_go_url: '', // go码url

      uploadUrl: '',
      logo: {
        logo_url: require('@/assets/logo.png'),
        flag: false // 是否上传了图片
      },
      sys_title: '',
      default_sys_title: 'AIOT 平台'
    }
  },

  methods: {
    initData() {
      this.sys_title = this.$store.state.godStore.customization
        ? this.$store.state.godStore.customization.console_title
          ? this.$store.state.godStore.customization.console_title
          : ''
        : ''
      this.logo.logo_url = this.$store.state.godStore.customization
        ? this.$store.state.godStore.customization.console_imgurl
          ? this.$store.state.godStore.customization.console_imgurl
          : require('@/assets/logo.png')
        : require('@/assets/logo.png')
      this.logo.flag = this.$store.state.godStore.customization
        ? this.$store.state.godStore.customization.console_imgurl
          ? true
          : false
        : false
    },
    onLogoChange(arr) {
      this.logo.logo_url = arr.length === 0 ? require('@/assets/logo.png') : arr[0].url
      this.logo.flag = arr.length === 0 ? false : true
    },
    jumpTo(kwd) {
      // 上一步、下一步
      if (this.active === 'monitor' && kwd === 'pre') {
        this.nav_title = '快速入门'
        this.nav_sm_title = '欢迎使用鱼漾云'
        this.content_title = 'Welcome'
        this.active = 'start'
      } else if ((this.active === 'start' && kwd === 'next') || (this.active === 'equip' && kwd === 'pre')) {
        if (this.active === 'start' && kwd === 'next') {
          // 提交用户平台名称以及Logo处理
          // let url = this.logo.logo_url.indexOf('/img/logo') === -1 ? this.logo.logo_url : ''
          // let query = {
          //   console_title: this.sys_title,
          //   console_imgurl: url
          // }
            // this.$store.dispatch('setGodCustomizationAction', query).then(res => {
            //   if (!res.errno) {
            //     // localStorage.setItem('__LOGIN_BG__', this.customization.login_bg_imgurl)
            //     // localStorage.setItem('__LOGIN_TITLE__', this.customization.login_title)
            //     localStorage.setItem('__LOGIN_CONSOLE_TITLE__', this.customization.console_title)
            //   } else {
            //     this.$message.error(res.message)
            //   }
            // })
          this.timerIndex = 0
          this.nav_title = '如何实现？'
          this.nav_sm_title = '物理设备加装通讯模块即可接入云平台，实现远程监控'
          this.content_title = '远程通讯原理'
          this.active = 'monitor'
          let _this = this
          clearInterval(_this.timer)
          this.timer = setInterval(function () {
            _this.timerIndex += 1
            if (_this.timerIndex >= 10) {
              clearInterval(_this.timer)
            }
          }, 800)
        } else {
          this.timerIndex = 0
          this.nav_title = '如何实现？'
          this.nav_sm_title = '物理设备加装通讯模块即可接入云平台，实现远程监控'
          this.content_title = '远程通讯原理'
          this.active = 'monitor'
          let _this = this
          clearInterval(_this.timer)
          this.timer = setInterval(function () {
            _this.timerIndex += 1
            if (_this.timerIndex >= 10) {
              clearInterval(_this.timer)
            }
          }, 800)
        }
      } else if ((this.active === 'monitor' && kwd === 'next') || (this.active === 'addmodel' && kwd === 'pre')) {
        this.nav_title = '添加设备'
        this.nav_sm_title = '平台会为每台设备分配一个GO码，作为唯一身份标识请扫码联系我们采购通讯模块或申请样机'
        this.content_title = '添加设备'
        this.active = 'equip'
      } else if ((this.active === 'equip' && kwd === 'next') || (this.active === 'loadmodel' && kwd === 'pre')) {
        this.nav_title = '创建模型'
        this.nav_sm_title = '模型，就是同一种型号的设备，即您的产品型号'
        this.content_arr = ['添加设备', '创建模型']
        this.active = 'addmodel'
      } else if ((this.active === 'addmodel' && kwd === 'next') || (this.active === 'experience' && kwd === 'pre')) {
        this.nav_title = '加载模型'
        this.nav_sm_title = '为设备加载模型'
        this.content_arr = ['添加设备', '创建模型', '加载模型']
        this.active = 'loadmodel'
      } else if (this.active === 'loadmodel' && kwd === 'next') {
        this.loadEquipModel().then(res => {
          if (!res.errno) {
            this.nav_title = '扫码体验'
            this.nav_sm_title = '现在您可以远程监控您的设备啦！<br/>打开微信扫一扫，关注公众号，即刻体验~'
            this.content_title = ''
            this.active = 'experience'
          }
        })
      }
    },
    jumpGuide() {
      // 跳过教程，回到首页
      this.$router.push('/')
    },
    loadEquipModel() {
      this.loading = true
      return new Promise((resolve, reject) => {
        loadEquipModelApi().then(res => {
          if (!res.errno) {
            this.loading = false
            // console.log('演示模型加载成功!')
            getDemoEquipApi()
              .then(r => {
                if (!res.errno) {
                  this.equip_go_url = r.data.go_image
                  resolve(r)
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch(e => {
                reject(e)
              })
          } else {
            reject(res)
            this.$message.error(res.message)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.guide {
  .container {
    width: 100%;
    height: 100%;
    min-width: 1080px;
    min-height: 820px;
    .container-nav {
      width: 550px;
      max-width: 600px;
      min-width: 500px;
      height: 100%;
      background-color: #fff;
      padding: 150px 100px 0;
      .start-body,
      .start-footer,
      .monitor-body,
      .common-footer,
      .equip-body,
      .addmodel-body,
      .loadmodel-body,
      .experience-body {
        margin-top: 60px;
      }
      .monitor-body {
        .item {
          width: 340px;
          padding: 20px;
          border: 2px solid #dbdada;
          .mon-icon {
            width: 48px;
            height: 48px;
          }
        }
      }
      .addmodel-body {
        .model-num {
          text-shadow: 2px 2px 10px #07c160;
          color: #07c160;
          font-weight: bold;
          font-style: italic;
          font-size: 40px;
          font-family: SourceHanSansSC-regular;
        }
      }
      .loadmodel-body {
        width: 100%;
        .arrow-img {
          width: 150px;
          height: 100px;
          img {
            filter: grayscale(100%);
            width: 20px;
            transform: rotate(90deg);
          }
        }
        .model-icon {
          width: 60px;
          height: 60px;
          font-size: 60px;
        }
      }
      .experience-body {
        .go-img {
          width: 150px;
          height: 150px;
          margin-bottom: 60px;
          box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.4);
        }
      }
    }
    .container-content {
      position: relative;
      flex: auto;
      height: 100%;
      background-color: #f9f9f9;
      .body {
        flex: none;
        width: 1080px;
        position: relative;
        margin: 0 auto;
        .bg {
          width: 100%;
        }
        .logo {
          width: 26px;
          height: 26px;
          position: absolute;
          top: 4px;
          left: 5px;
        }
        .sys-title {
          position: absolute;
          top: 5px;
          left: 40px;
          color: #fff;
        }
        .user-info {
          position: absolute;
          top: 8px;
          right: 25px;
        }
        .monitor-img {
          width: 80%;
          -webkit-transition: all 0.5s ease-in;
          -moz-transition: all 0.5s ease-in;
          transition: all 0.5s ease-in;
        }
        .link-layer {
          width: 100%;
          justify-content: space-evenly;
          padding: 0 150px;
          box-sizing: border-box;
          .link-layer-item {
            -webkit-transition: all 0.5s ease-in;
            -moz-transition: all 0.5s ease-in;
            transition: all 0.5s ease-in;
          }
        }
      }
      .top-tag {
        flex: auto;
        margin-top: 50px;
        position: relative;
        .tag-item {
          position: relative;
          .item-title {
            padding-bottom: 6px;
            position: absolute;
            top: 30px;
            left: 50px;
            transform: translate3d(0, -50%, 0);
            color: #fff;
          }
        }
        .bg {
          height: 60px;
        }
        .title {
          padding-bottom: 6px;
          position: absolute;
          top: 30px;
          left: 30px;
          transform: translate3d(0, -50%, 0);
          color: #fff;
        }
      }
      .bottom-tag {
        flex: auto;
        margin-bottom: 50px;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        .bg {
          width: 240px;
        }
      }
      .box-shadow {
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
      }
    }
  }
}
</style>
